import { Autocomplete, TextField } from '@mui/material'
import { DatePicker } from '@mui/x-date-pickers'

import type { GridRenderEditCellParams } from '@mui/x-data-grid-pro'
import type { DropdownOption } from 'shared/models/dropdownOption'
import type { AttributeRow } from './Attributes'

export function EditCell({ row, api }: GridRenderEditCellParams<AttributeRow>) {
    const { freetext, options, attribute, id, multiple, yearpicker } = row

    const handleValueChange = async (value: typeof attribute | null) => {
        await api.setEditCellValue({ id, field: 'attribute', value })
    }

    if (yearpicker) {
        return (
            <DatePicker
                value={attribute instanceof Date ? attribute : null}
                onChange={(date) => handleValueChange(date)}
                views={['year']}
                format="yyyy"
                sx={{
                    width: '100%',
                    '& .MuiFormControl-root': {
                        height: '100%',
                    },
                    '& .MuiInputBase-root': {
                        height: '100%',
                        borderRadius: '0px',
                    },
                }}
            />
        )
    }

    if (freetext) {
        return (
            <TextField
                defaultValue={attribute}
                onChange={(event) => handleValueChange(event.target.value)}
                fullWidth
                sx={{
                    '& .MuiFormControl-root': {
                        height: '100%',
                    },
                    '& .MuiInputBase-root': {
                        height: '100%',
                        borderRadius: '0px',
                    },
                }}
            />
        )
    }

    return (
        <Autocomplete
            onChange={(event, value) => handleValueChange(value)}
            multiple={multiple}
            options={options ?? []}
            value={
                Array.isArray(attribute)
                    ? attribute.filter((v) => Boolean(v.id))
                    : attribute ?? null
            }
            getOptionLabel={(option: DropdownOption) => option.value}
            fullWidth
            sx={{
                '& .MuiFormControl-root': {
                    height: '100%',
                },
                '& .MuiInputBase-root': {
                    height: '100%',
                    borderRadius: '0px',
                },
            }}
            isOptionEqualToValue={(option) =>
                Array.isArray(attribute)
                    ? attribute.map((v) => v.id).includes(option.id)
                    : attribute?.id === option.id
            }
            renderInput={(renderParams) => (
                <TextField
                    {...renderParams}
                    fullWidth
                    placeholder=""
                    inputProps={{
                        ...renderParams.inputProps,
                        height: '100%',
                    }}
                />
            )}
        />
    )
}
